export default (placement => placement.split('-')[0]);